import { useState } from 'react'
import $ from 'jquery'
import { RegItemAddSuccessModal } from '../store/components/product-details-page/product-actions/reg-item-add-success-modal'
import { RegistrySaveItemResponse } from '../responses'
import { track, withContextualizedTracking } from '../lib/analytics'

export interface BookmarkletItemAddSuccessModalProps {
  data: Pick<RegistrySaveItemResponse, 'recommendedProducts' | 'metadata'>
}

function BookmarkletItemAddSuccessModal({
  data,
}: BookmarkletItemAddSuccessModalProps) {
  const [show, setShow] = useState(true)

  function handleOnHide() {
    setShow(false)
    // This dismisses the modal backdrop created by jquery
    $('.js-dismiss-modal').trigger('click')
  }

  return (
    <RegItemAddSuccessModal
      id="reg-item-add-success-modal"
      // Jquery is handling the backdrop
      renderBackdrop={() => null}
      onHide={handleOnHide}
      // @ts-ignore
      addNextRecommendation={data}
      ProductViewedEventProps={{
        event: track.productRecommendationsViewed,
        productRecommenderModelVersion: data.metadata.modelVersion,
        eventLocation: BookmarkletItemAddSuccessModal.Constants.EVENT_LOCATION,
      }}
      ProductClickedEventProps={{
        event: track.productRecommendationClicked,
        productRecommenderModelVersion: data.metadata.modelVersion,
        eventLocation: BookmarkletItemAddSuccessModal.Constants.EVENT_LOCATION,
      }}
      openInNewWindow
      show={show}
    />
  )
}

BookmarkletItemAddSuccessModal.Constants = {
  EVENT_LOCATION: track.EventLocation.NEXT_ADD_RECOMMENDER,
}

export default withContextualizedTracking()(BookmarkletItemAddSuccessModal)
